export interface IProductCounts {
  active?: number
  recycled?: number
  drafts?: number
}

export interface IProductsMetaState {
  isNext?: boolean
  totalStatus?: string
  carrierId?: number
  categoryIds?: number[]
  page?: number
  perPage?: number
  query?: string
  sort?: string
  total?: number
  userId?: number
  active?: boolean
  all?: boolean
  draft?: boolean
  recycled?: boolean
  inventoryLocationId?: number
  supplierId?: number
  listingStrategyId?: number
  hideFulfilled?: boolean
  createdAt?: Date[]
  excludePrinted?: boolean
  tags?: string[]
  onlyAuthenticated?: boolean
  photographedBy?: number
  hasPhotos?: boolean
  ignoreRecycledFilter?: boolean
}

export interface IProductsFilters {
  supplier?: string
  inventoryLocation?: string
  listingStrategy?: string
  user?: string
  category?: string
  tags?: string
  photographer?: string
}
export const ProductMetaAction = {
  UPDATE_META: 'UPDATE_PRODUCT_META',
  RESET_META: 'RESET_PRODUCT_META'
} as const

export type ProductMetaActionType = {
  type: typeof ProductMetaAction[keyof typeof ProductMetaAction]
  payload: Partial<IProductsMetaState>
}

export type onMetaChangeHandler = (
  key: keyof IProductsMetaState,
  value: unknown,
  resetPagination?: boolean,
  shouldDebounce?: boolean,
  shouldRefetch?: boolean
) => void

export enum ExportType {
  CURRENT_FILTERS = 'currentFilters',
  ALL = 'all',
  SELECTED = 'selected',
  BY_DATE = 'byDate'
}

export interface MarketAccountLite {
  id: number
  marketId: number
}
